import React, { useState, useEffect } from "react";
import { API } from "aws-amplify";
import { updateSession as updateSessionMutation } from "./../../graphql/mutations";

import Modal from "react-bootstrap/Modal";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import Spinner from "react-bootstrap/Spinner";

type Props = $ReadOnly<{
  show: boolean,
  session: ?{
    id: string,
    name: string,
    organizationName?: string,
  },
  onClose: () => void,
  onSaved: () => void,
}>;

export default function SessionEditModal(props: Props): React$Element<any> {
  const [editName, setEditName] = useState("");
  const [editOrganizationName, setEditOrganizationName] = useState("");
  const [saving, setSaving] = useState(false);

  // 세션 바뀔 때마다 input 초기화
  useEffect(() => {
    if (props.session) {
      setEditName(props.session.name);
      setEditOrganizationName(props.session.organizationName ?? "");
    }
  }, [props.session]);

  async function updateSession() {
    if (!props.session) return;

    setSaving(true);
    await API.graphql({
      query: updateSessionMutation,
      variables: {
        input: {
          id: props.session.id,
          name: editName,
          organizationName: editOrganizationName,
        },
      },
    });
    setSaving(false);
    props.onSaved();
  }

  return (
    <Modal show={props.show} onHide={props.onClose} backdrop="static">
      <Modal.Header closeButton>
        <Modal.Title>Edit Session Name</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <Form.Group>
          <Form.Label>Enter New Name</Form.Label>
          <Form.Control
            type="text"
            value={editName}
            onChange={(e) => setEditName(e.target.value)}
          />
          <Form.Label>Enter New Organization</Form.Label>
          <Form.Control
            type="text"
            value={editOrganizationName ?? ""}
            onChange={(e) => setEditOrganizationName(e.target.value)}
          />
        </Form.Group>
      </Modal.Body>

      <Modal.Footer>
        <Button variant="secondary" onClick={props.onClose}>
          Cancel
        </Button>
        <Button onClick={updateSession} disabled={saving}>
          {saving && (
            <Spinner
              animation="border"
              variant="light"
              size="sm"
              className="me-2"
            />
          )}
          Save
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
